import React from 'react';
import moment from 'moment';
import {Colors} from '../../../../../../styles/Colors';
import {GlobalStyleAttributes} from '../../../../../../styles/GlobalStyles';
import {dbDateFormat, getBoxDateFormat} from '../../../../../../services/Helpers';
import {t} from '../../../../../../services/i18n';
import Box from '../../../../../common/Layout/Box';
import VStack from '../../../../../common/Layout/VStack';
import AppText from '../../../../../common/AppText';
import RadioListItem from '../../../../../common/RadioListItem';
import {formatSwapDayTimeLabel, isTrackSwapWeeklyLimitReached} from './trackSwapHelpers';

const SwapCourseFromTrack = (props) => {
    const {seriesTrackRelation, days, selectedEventId, onSelect, fromSeriesId = null, showAvailability = false} = props;
    const series = seriesTrackRelation.series;

    const formatDate = (date) => moment(date, dbDateFormat).format(getBoxDateFormat());
    const formatSwapDateRange = (startDate, endDate) => {
        if (!startDate) {
            return '';
        }
        if (!endDate) {
            return formatDate(startDate);
        }
        return `${formatDate(startDate)}–${formatDate(endDate)}`;
    };
    const getTrackStaffNames = (series) => [series?.coach, series?.second_coach].filter(Boolean).map(staff => `${staff.first_name} ${staff.last_name || ''}`.trim()).join(', ');

    const subtitle = [formatSwapDateRange(series.start_date, series.end_date), getTrackStaffNames(series)].filter(Boolean).join(' · ');
    const limitReached = showAvailability && isTrackSwapWeeklyLimitReached(seriesTrackRelation, fromSeriesId);

    return (
        <VStack space={'0'}>
            <VStack style={{padding: '16px 12px 8px'}} space={'0'}>
                <AppText mediumFont fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.mainText}>
                    {series.series_name}
                </AppText>
                {subtitle && (
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>
                        {subtitle}
                    </AppText>
                )}
            </VStack>
            {days.map((day) => {
                const isFull = showAvailability && day.spots_left != null && day.spots_left <= 0;
                return (
                    <RadioListItem
                        key={day.id}
                        label={formatSwapDayTimeLabel(day)}
                        isSelected={!limitReached && selectedEventId === day.id}
                        disabled={limitReached}
                        onSelect={() => onSelect(day.id)}
                        endContent={showAvailability && (limitReached ? (
                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey} style={{textAlign: 'end'}}>
                                {t('track-swap-weekly-limit-reached')}
                            </AppText>
                        ) : isFull ? (
                            <Box backgroundColor={Colors.newDesign.tableBackgroundColor} padding={'2px 8px'} borderRadius={'2px 2px 2px 0'} flexShrink={0}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>
                                    {t('track-swap-class-full')}
                                </AppText>
                            </Box>
                        ) : day.spots_left != null && (
                            <Box backgroundColor={Colors.newDesign.lightGreen} padding={'2px 8px'} borderRadius={'2px 2px 2px 0'} flexShrink={0}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.mainGreen}>
                                    {t('spots-remaining', {count: day.spots_left})}
                                </AppText>
                            </Box>
                        ))}
                    />
                );
            })}
        </VStack>
    );
};

export default SwapCourseFromTrack;
